import Apollo from '@/graphql/vue-apollo'
import Router from '@/router'

const client = Apollo.instance.defaultClient

function clear() {
  set([])
}

function set(breadcrumbs) {
  client.writeData({
    data: {
      breadcrumbs: breadcrumbs.map((c, i) => ({
        __typename: 'Breadcrumb',
        active: i === breadcrumbs.length - 1,
        url: c.url ? Router.resolve(c.url).href : '',
        label: c.label
      }))
    }
  })
}

export default {
  clear,
  set
}
